<script setup>
import CheckboxCustomButton from "../../base/checkbox-cutom-button/index.vue";
import { computed } from "vue";

const props = defineProps({
  modelValue: Array,
});
const emits = defineEmits(["update:modelValue"]);

const modelValueComputed = computed({
  get() {
    return props.modelValue;
  },
  set(evt) {
    emits("update:modelValue", evt);
  },
});
// "ที่พักอาศัยตั้งอยู่บน
// HT1 : ที่ดินมีกรรมสิทธิ์ของตนเอง
// HT2 : ที่ดินของผู้อื่น
// HT3 : ที่สาธารณะ (บุกรุก)
// HT4 : เช่า
// HT5 : อื่นๆ
// ตัวอย่าง
// const test ={
//     code: 'HT2',
//     desc: 'ที่ดินของผู้อื่น',
//     land_hiring: 'ผู้ให้เช่า',
//     hiring_cost: 1000,
// }
// หรือ
// {
//     ""code"": ""HT3"",
//     ""desc"": ""ที่สาธารณะ (บุกรุก)"",
//     ""public_land_type"": {
//       ""code"": ""PL5"",
//       ""desc"": ""อื่นๆ"",
//       ""public_land_name"": ""ไม่ทราบ""
//     },
// }
// หรือ
// {
//     ""code"": ""HT4"",
//     ""desc"": ""เช่า"",
//     ""rental_fee"": 1000
// }
// หรือ
// {
//     ""code"": ""HT5"",
//     ""desc"": ""อื่นๆ"",
//     ""house_type_name"": ""ที่ราชการ""
//   }"
</script>

<template>
  <section data-test="filter-accommodation-section">
    <div class="mt-3">
      <h4 class="text-base font-normal leading-none text-theme-33">
        ที่พักอาศัย
      </h4>
    </div>

    <div class="flex flex-wrap mt-2">
      <CheckboxCustomButton
        id="owner-checkbox"
        :value="{
          code: 'HT1',
          desc: 'ที่ดินมีกรรมสิทธิ์ของตนเอง',
        }"
        text="ที่ดินมีกรรมสิทธิ์ของตนเอง"
        class="mx-1 my-1"
        v-model="modelValueComputed"
      />
      <CheckboxCustomButton
        id="other-checkbox"
        :value="{
          code: 'HT2',
          desc: 'ที่ดินของผู้อื่น',
        }"
        text="ที่ดินของผู้อื่น"
        class="mx-1 my-1"
        v-model="modelValueComputed"
      />
      <CheckboxCustomButton
        id="public-checkbox"
        :value="{
          code: 'HT3',
          desc: 'ที่สาธารณะ (บุกรุก)',
        }"
        text="ที่สาธารณะ (บุกรุก)"
        class="mx-1 my-1"
        v-model="modelValueComputed"
      />
      <CheckboxCustomButton
        id="rent-checkbox"
        :value="{
          code: 'HT4',
          desc: 'เช่า',
        }"
        text="เช่า"
        class="mx-1 my-1"
        v-model="modelValueComputed"
      />
      <CheckboxCustomButton
        id="etc-checkbox"
        :value="{
          code: 'HT5',
          desc: 'อื่นๆ',
        }"
        text="อื่นๆ"
        class="mx-1 my-1"
        v-model="modelValueComputed"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
input[type="checkbox"] {
  display: none;
}
</style>
